import { AccountAuthorityManagementPage } from "./AccountAuthorityManagementPage";
export default AccountAuthorityManagementPage;
